const strict = true;

const state = {};

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
